export const colors = {
  defaultColor: "#ccc",
  fuchsia: "rgb(255, 0, 212)",
  blue: "#00A2ED",
  green: "#4AF626",
  darkGreen: "#29AB87",
  yellow: "#F1C232",
  darkPurple: "#18112e"
};